import { useState, useMemo } from 'react'
import { useQuery } from '@tanstack/react-query'
import categoryService from '../services/category.service'

export const useCategories = () => {
    const [searchText, setSearchText] = useState('')
    const [statusFilter, setStatusFilter] = useState<string>('all')

    // Fetch categories from API
    const { data: categories = [], isLoading, isFetching, error, refetch } = useQuery({
        queryKey: ['categories'],
        queryFn: categoryService.getCategories,
    })

    // Filter categories based on search and status
    const filteredCategories = useMemo(() => {
        return categories.filter(category => {
            const matchesSearch = category.name.toLowerCase().includes(searchText.toLowerCase()) || 
                                  category.description?.toLowerCase().includes(searchText.toLowerCase())
            const matchesStatus = statusFilter === 'all' || category.status === statusFilter

            return matchesSearch && matchesStatus
        })
    }, [categories, searchText, statusFilter])

    return {
        categories: filteredCategories,
        searchText,
        setSearchText,
        statusFilter,
        setStatusFilter,
        totalCategories: categories.length,
        isLoading,
        isFetching,
        error,
        refetch,
    }
}
